// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/collectRailContent.test.ts

// why: ChatAtoms wraps reviewPreflight.startReview in `**Header:**` on submit;
// progress must not run until that user message exists (preflight subagents are earlier).
/** Mirrors `reviewPreflight.startReview` in every `ui.json` locale. */
export const REVIEW_PREFLIGHT_START_HEADERS = [
  "Start review",
  "Lancer la revue",
  "Iniciar revisión",
  "Iniciar revisão",
  "Prüfung starten",
  "بدء المراجعة",
] as const;

export function isReviewStartUserMessage(content: string): boolean {
  const trimmed = content.trim();
  for (const header of REVIEW_PREFLIGHT_START_HEADERS) {
    if (trimmed === `**${header}**`) return true;
    if (trimmed.startsWith(`**${header}:** `)) return true;
  }
  return false;
}
